export default {
    appName: "Brandboosta",
    domain: process.env.NODE_ENV == 'production'? 'https://www.brandboosta.co' : 'http://127.0.0.1:8000',
    localUserKey: "brandboosta_udt"
}
